import { render, staticRenderFns } from "./BellEdit.vue?vue&type=template&id=6dd98e88&scoped=true"
import script from "./BellEdit.vue?vue&type=script&lang=js"
export * from "./BellEdit.vue?vue&type=script&lang=js"
import style0 from "./BellEdit.vue?vue&type=style&index=0&id=6dd98e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd98e88",
  null
  
)

export default component.exports